import { render, staticRenderFns } from "./oldTree.vue?vue&type=template&id=4e50c5c1&"
import script from "./oldTree.vue?vue&type=script&lang=js&"
export * from "./oldTree.vue?vue&type=script&lang=js&"
import style0 from "./oldTree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports